import { Injectable } from '@angular/core';

import { VALIDATION_ERRORS } from '@com-delta-idp/mnx-sitewide-shared-utils';
import { Dropdown } from '@com-delta-omnichannel/mach-core-js';
import {
  CheckInWidget,
  CheckInWidgetFormType
} from '../models/check-in-widget.interfaces';
import { CheckInWidgetInitializationHelperService } from './check-in-widget-initialization-helper.service';

@Injectable({
  providedIn: 'root'
})
export class CheckInWidgetInitializationService extends CheckInWidgetInitializationHelperService {
  initializeComponents(content: CheckInWidget): {
    dropDownCheckInOptions: Dropdown;
  } {
    return {
      dropDownCheckInOptions: new Dropdown(content.dropDownCheckInOption)
    };
  }

  errorValidation(
    form: CheckInWidgetFormType,
    content: CheckInWidget,
    tripByValue: string
  ): void {
    this.tripValueErrorValidation(form, content, tripByValue);
    if (!this.hideLastName) {
      this.lastNameErrorValidation(form, content);
    }
    this.originAirportErrorValidation(form, content);

    const errorFlags = [
      this.errorContent.showLastNameError,
      this.errorContent.showTripTypeError,
      this.errorContent.showOriginAirportError
    ];
    this.errorContent.errorCount = errorFlags.filter(Boolean).length;
    this.errorContent.showAlert = this.errorContent.errorCount > 0;
  }

  tripValueErrorValidation(
    form: CheckInWidgetFormType,
    content: CheckInWidget,
    tripByValue: string
  ): void {
    if (form.findTripByValue.invalid) {
      if (form.findTripByValue.errors?.[VALIDATION_ERRORS.REQUIRED]) {
        this.errorContent.tripTypeError = this.getTripTypeError(
          content,
          VALIDATION_ERRORS.REQUIRED,
          tripByValue
        );
        this.errorContent.showTripTypeError = true;
      } else {
        this.errorContent.tripTypeError = this.getTripTypeError(
          content,
          VALIDATION_ERRORS.INVALID,
          tripByValue
        );
        this.errorContent.showTripTypeError = true;
      }
    } else {
      this.errorContent.showTripTypeError = false;
    }
  }

  lastNameErrorValidation(
    form: CheckInWidgetFormType,
    content: CheckInWidget
  ): void {
    if (form.lastName.invalid) {
      if (form.lastName.errors?.[VALIDATION_ERRORS.REQUIRED]) {
        this.errorContent.lastNameError = content.errors.last_Name.required;
      } else {
        this.errorContent.lastNameError = content.errors.last_Name.invalid;
      }
      this.errorContent.showLastNameError = true;
    } else {
      this.errorContent.showLastNameError = false;
    }
  }

  originAirportErrorValidation(
    form: CheckInWidgetFormType,
    content: CheckInWidget
  ): void {
    if (
      form.originAirportCode.invalid &&
      form.originAirportCode.errors?.[VALIDATION_ERRORS.REQUIRED]
    ) {
      this.errorContent.originAirportError = content.errors.fromCity.required;
      this.errorContent.showOriginAirportError = true;
    } else {
      this.errorContent.showOriginAirportError = false;
    }
  }

  checkForm(formCheckIn: CheckInWidgetFormType, redirectUrl: string): void {
    this.redirectFunction(formCheckIn, redirectUrl);
  }

  processSubmission(
    formCheckIn: CheckInWidgetFormType,
    content: CheckInWidget,
    title?: string,
    valid?: boolean
  ): void {
    if (title) this.errorValidation(formCheckIn, content, title);
    if (valid) {
      this.checkForm(formCheckIn, content.checkInRedirectUrl);
    }
  }
}
